import React, { useState, useEffect } from "react";
import "antd/dist/antd.css";
import {Form,
  Select,
  InputNumber,
  Button,
  Upload,
  Input,
  Typography,
  Checkbox,
} from "antd";
import { RollbackOutlined } from "@ant-design/icons";
import { postAdd } from "../../../services/pickerpacker.service";
import { validationErrors } from "../../../utils/Helpers";
import { swalNotification } from "../../../components/alret/notificztion";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as zoneActions from "../../../redux/actions/zone.actions";

const { Title } = Typography;
const pageName = "Picker Packer";
const pageLink = "pickerpacker";

const cityOption = [
  {value: 'Karachi', label: 'Karachi'},
  {value: 'Lahore', label: 'Lahore'},
  {value: 'Rawalpindi', label: 'Rawalpindi'},
]

const normFile = (e) => {
  if (Array.isArray(e)) {
    return e;
  }
  return e && e.fileList;
};

const PickerPackerCreate = (props) => {
  const navigate = useNavigate();
  const [MBtnLoading, setMBtnLoading] = useState(false);
  const [postDataZone, setPostDataZone] = useState(null);

  useEffect(() => {
    postListsZones()
  }, []);

  const postListsZones = async() => {
    await props.zoneActions.getZoneListAction();
  }

  useEffect(() => {
    if (props.zoneData) {
      const zoneData = [];
      props.zoneData.map((item) => {
        zoneData.push({value: item?.id, label: item?.zoneName})
      });
      setPostDataZone(zoneData);
    }
  }, [props.zoneData]);

  const onFinish = async (values) => {
    if (values.profileImage === undefined) {
      swalNotification(
        "Validation Error",
        "Profile Image is Required",
        "error"
      );
      return null;
    } else {
      values.profileImage = values.profileImage[0].originFileObj;
    }

    const headers = {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      UserId: parseInt(localStorage.getItem("user_id")),
    };

    try {
      setMBtnLoading(true);
      const resp = await postAdd(values, headers);
      if (resp.data.code == 200) {
        swalNotification("Picker Packer Added", resp.data.message, "success");
        navigate(`/${pageLink}`);
      }
    } catch (error) {
      validationErrors(error);
    } finally {
      setMBtnLoading(false);
    }
  };
  const [state, setState] = useState({
    loading: false,
  });

  const uploadProfileImageButton = (
    <div>
      <div className="ant-upload-text">Upload Profile Image</div>
    </div>
  );

  const { imageUrl } = state;
  return (
    <div className="page-content">
      <div className="page-content-header">
        <Title level={2}>{pageName} Add</Title>
        <div className="pch">
          <Button onClick={() => navigate(`/${pageLink}`)}><RollbackOutlined /></Button>
        </div>
      </div>
      <div className="p-content">
        <Form name="validate_other" onFinish={onFinish} layout="vertical" >
          <Form.Item
            name={["fullName"]}
            label={"Name"}
            rules={[{required: true, message: "Your Full Name is Required"}]}
          >
            <Input placeholder="Full Name"/>
          </Form.Item>
          <Form.Item
            name={"cnic"}
            label={"CNIC Number"}
            rules={[
              {required: true, message: "Your CNIC number is required", pattern: new RegExp(/^[0-9]+$/),},
              {type: "number", min: 1000000000000, max: 9999999999999, message: "Please enter your complete CNIC number",},
            ]}
          >
            <InputNumber placeholder="CNIC" style={{width:'100%'}} />
          </Form.Item>
          <Form.Item
            name={"city"}
            label={"City"}
            rules={[{required: true, message: "City is Required"}]}
          >
            <Select
              showSearch
              allowClear
              filterOption={(input, option)=>(option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
              options={cityOption}
              style={{minWidth: "200px"}}
            />
          </Form.Item>
          <Form.Item
            name={"phoneNumber"}
            label={"Phone Number"}
            rules={[
              {required: true, message: "Your Phone Number is Required"},
              {pattern: /^(\+92)[0-9]{10}$/, message: "+923000000000 Phone number format. 10 numbers add after +92 "},
            ]}
          >
            <Input placeholder="Phone Number eg.+92**" />
          </Form.Item>
          <Form.Item
            name={"email"}
            label={"Email"}
            rules={[{type: "email", required: true, message: "Email is Required"}]}
          >
            <Input placeholder="Email" />
          </Form.Item>
          <Form.Item
            name={"password"}
            label={"PassCode"}
            rules={[
              {required: true, message: "Your PassCode number is required", pattern: new RegExp(/^[0-9]+$/)},
              {type: "number", min: 0, max: 9999, message: "Please enter your complete PassCode number"}
            ]}
          >
            <InputNumber placeholder="PassCode" style={{width:'100%'}} />
          </Form.Item>
            
          <Form.Item
            name="profileImage"
            valuePropName="fileList"
            getValueFromEvent={normFile}
          >
            <Upload
              listType="picture-card"
              className="avatar-uploader"
              showUploadList={true}
              maxCount={1}
            >
              {imageUrl ? (
                <img
                  src={imageUrl}
                  alt="avatar"
                  style={{ width: "100%" }}
                />
              ) : (
                uploadProfileImageButton
              )}
            </Upload>
          </Form.Item>
          <Form.Item
            name={"zone"}
            label={"Zone"}
            rules={[{ required: true, message: "Zone is required" }]}
          >
            <Select
              placeholder="Select a zone"
              options={postDataZone}
              showSearch
              optionFilterProp="label"
              filterOption={(input, option) =>
                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
              }
            />
          </Form.Item>
          <Form.Item
            name="role"
            label="Roles"
            rules={[{ required: true, message: "At least one role is required" }]}
          >
            <Checkbox.Group>
              <Checkbox value="picker">Picker</Checkbox>
              <Checkbox value="packer">Packer</Checkbox>
            </Checkbox.Group>
          </Form.Item>
          <Button type="primary" htmlType="submit" loading={MBtnLoading}>Submit</Button>
        </Form>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    // user: state.authReducer.user,
    // permissions: state.PermissionReducer.permissions,
    // pageData: state.PickerPakerPageReducer?.initialDetail,
    pageLoading: state.PickerPakerPageReducer?.initialLoading,
    zoneData: state.ZoneReducer.zoneData,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    // actionPage: bindActionCreators(actionPage, dispatch),
    zoneActions: bindActionCreators(zoneActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PickerPackerCreate);